<template>
    <ion-toolbar>
        <ion-buttons slot="start" v-if="$store.state.pages.auth.back.length">
            <ion-button class="button_back" @click="goBack">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
            <ion-button @click="skip" class="pill next-pill-button">
                <span>Skip</span>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
        <div class="container">
            <div class="auth-header">
                <div class="auth-heading">
                    <h1>Pharmacy Management Software</h1>
                    <span>{{ softwareExperienceCustomFields.length > 0 ? softwareExperienceCustomFields[0].label :
                    '' }}</span>
                </div>
                <div class="brand-icon" >
                    <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none"/>
                </div>
            </div>    
            <el-form class="full_page" :label-position="'top'" @submit.prevent="goNext('userForm')">

                <el-form-item prop="schedule" class="job_filters_form_checkbox">
                    <template v-if="softwareExperienceCustomFields.length > 0">
                        <template v-for="(field, index) in softwareExperienceCustomFields" :key="index">
                            <template v-if="field.fieldType === 'MultiSelectcheckbox'">
                                <el-checkbox-group v-model="form.selectedValues">
                                    <div v-for="(value, i) in field.values" :key="i">
                                        <el-checkbox :label="value.label" @change="handleCheckboxChange(value, index)">{{
                    value.label }}</el-checkbox>
                                        <el-input v-if="isDynamicSelected(value)" v-model="form[value.label]"
                                            :placeholder="`Enter ${value.label}`"></el-input>
                                    </div>
                                </el-checkbox-group>
                            </template>
                            <el-form-item-error v-if="v$.selectedValues.$error">{{ v$.selectedValues.$errors[0].$message
                                }}</el-form-item-error>
                        </template>
                    </template>
                </el-form-item>
                <el-form-item class="button_submit mb0">
                    <el-button :disabled="isSubmitDisabled" class="submit_page w-full" type="blue" @click="goNext('userForm')">
                        Continue
                    </el-button>
                </el-form-item>
            </el-form>
            <div class="background-circles">
                <div class="circle circle-2"></div>
                <div class="circle circle-1"></div>
                <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none"/>
            </div>
        </div>
    </div>
</template>


<script>
import {
    onMounted,
    inject,
    onBeforeMount,
    ref,
    reactive,
    computed
} from 'vue';

import {
    addIcons
} from 'ionicons'
import {
    arrowBackOutline
} from 'ionicons/icons'
addIcons({
    'arrow-back-outline': arrowBackOutline
})
import {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
} from '@ionic/vue';

import {
    useStore
} from 'vuex'
import {
    useRouter,
    useRoute
} from 'vue-router'
import { useVuelidate } from '@vuelidate/core';
import { required, helpers } from '@vuelidate/validators';
import SvgIcon from '@/components/Svg/SvgIcon.vue';

export default {
    components: {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
        SvgIcon,
    },
    directives: {
    },
    setup() {
        const $store = useStore()
        const $router = useRouter()
        const setPageClassGlobal = inject('setPageClassGlobal');
        const $route = useRoute()
        const softwareExperienceCustomFields = ref([]);
        console.log("🚀 ~ setup ~ customFields:", softwareExperienceCustomFields)
        console.log($store.getters.getJobFilters.schedule);

        const form = reactive({
            selectedValues: ref([]),

        });

        const rules = computed(() => {
            return {
                selectedValues: { required: helpers.withMessage('Please select software', required) },
            };
        });
        const v$ = useVuelidate(rules, form);
        const goBack = async() => {
            const back = await $store.dispatch("getAuthPageBack");
            $router.push({
                name: back,
            });
        };

        const isDynamicSelected = (value) => {
            return (
                form.selectedValues.includes(value.label) && value.showTextbox === true
            );
        };

        const goNext = async () => {
            const result = await v$.value.$validate();

            if (!result) {
                alert('The form has errors');
                return;
            } else {
                const values = [];

                for (const selectedValue of form.selectedValues) {
                    const otherValue = form[selectedValue] ? form[selectedValue] : "";
                    values.push({ value: selectedValue, other_value: otherValue });
                }

                const payload = [
                    {
                        key: 'software_experience',
                        values: values
                    }
                ]

                try {
                    await $store.dispatch("SAVE_USER_SOFTWARE_EXPERIENCE_DATA", payload);
                    $router.push({
                        name: "jobseeker_auth_pharmacy_experience",
                    });
                } catch (error) {
                    console.log(error);
                }
            }
        };

        const skip = () => {
            (async () => {
                try {
                    $store.dispatch('addAuthPageBack', $route.name);
                    $router.push({
                        name: 'jobseeker_auth_pharmacy_experience',
                    })
                } catch (error) {
                    console.log(error);
                }
            })();
          
        }

        const validateField = (fieldName) => {
            // Trigger validation for the specified field
            v$.value[fieldName].$touch();
        };

        onMounted(() => {
            setPageClassGlobal('global_auth_pharmacy_experience_page');

        });

        onBeforeMount(async () => {
            try {
                const response = await $store.dispatch("GET_CUSTOM_FIELDS",);
                console.log("🚀 ~ onBeforeMount ~ check:", response)
                softwareExperienceCustomFields.value = response.data.softwareExperience;
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        });

        const handleCheckboxChange = (value, index) => {
            console.log("🚀 ~ handleCheckboxChange ~ index:", index)
            console.log("🚀 ~ handleCheckboxChange ~ value:", value.label)
            // If the "Speciality" checkbox is checked, show the input field

            if (value.showTextbox && form.selectedValues.includes(value.label)) {
                const ruleKey = value.label;
                rules.value[ruleKey] = { required };

                // Add the otherInputValue[index] field to the form
                const fieldValue = "";
                form[ruleKey] = ref(fieldValue);

                // Touch the field to trigger validation
                v$.value.$touch(ruleKey);
            } else {
                console.log('on removeeeeee', value.label)
                const ruleKey = value.label;
                delete rules.value[ruleKey];
                delete form[ruleKey];
            }
        };


        const isSubmitDisabled = computed(() => {
            return Object.values(form).some(value => value.length == 0) || v$.value.$pending || v$.value.$error;
        });


        return {
            goBack,
            goNext,
            handleCheckboxChange,
            isDynamicSelected,
            softwareExperienceCustomFields, 
            form, 
            rules, 
            v$, 
            validateField, 
            isSubmitDisabled,
            skip
        }
    },
}
</script>